/**
 * DropdownMenu Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import onClickOutside from 'react-onclickoutside';
import { VelocityComponent } from 'velocity-react';

import Button, { ButtonProps } from '../../../atoms/buttons/Button';

export type DropdownMenuOptions = Array<'-' | React.ReactElement<ButtonProps>>;
export type DropdownMenuProps = IOwnProps;

interface IOwnProps {
  align?: 'left' | 'right' | 'justify';
  menu?: 'account' | 'help';
  Button: React.ReactElement<ButtonProps>;
  options: DropdownMenuOptions;
  requestClose?: boolean;
  className?: string;
  onToggle?(open: boolean): void;
}

interface IOwnState {
  active: boolean;
}

const classes = new BEM('dropdown-menu');

class DropdownMenu extends React.Component<DropdownMenuProps, IOwnState> {
  static defaultProps: Partial<DropdownMenuProps> = {
    align: 'left',
  };

  dropdownButton = React.createRef<Button>();

  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  componentDidUpdate(prevProps: IOwnProps) {
    if (!!!prevProps.requestClose && !!this.props.requestClose) {
      if (this.state.active) {
        this.toggleMenu(false, false);
      }
    }
  }

  onClickDropDownButton: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    this.toggleMenu();
  }

  handleClickOutside = () => {
    this.toggleMenu(false);
  }

  toggleMenu(active = !this.state.active, triggerToggle = true) {
    this.setState({ active }, () => {
      if (this.props.onToggle && triggerToggle) {
        this.props.onToggle(this.state.active);
      }
    });
  }

  renderMenu() {
    const modifiers = {
      [this.props.align!]: true,
      [this.props.menu!]: true,
    };
    return (
      <div onClick={this.handleClickOutside} {...classes('', modifiers)}>
        {this.props.options.map((option, index) => {
          if (option === '-') {
            return <div key={`sep-${index}`} {...classes('sep')} />;
          }

          const OptionButton = React.cloneElement<ButtonProps>(option, {
            onClick: (e) => {
              e.persist();
              this.toggleMenu(false);
              if (option.props.onClick) {
                option.props.onClick(e);
              }
            },
            className: classNames('dropdown-menu__option-button', option.props.className),
          });

          return OptionButton;
        })}
      </div>
    );
  }

  render() {
    const { active } = this.state;
    const DropdownButton = React.cloneElement<ButtonProps & React.Props<Button>>(this.props.Button, {
      ...this.props.Button.props,
      ref: this.dropdownButton,
      onClick: this.onClickDropDownButton,
      ...classes('dropdown-button', '', classNames(
        this.props.Button.props.className,
        active ? 'button--is-active' : '',
        this.props.className,
      )),
    });

    return (
      <div {...classes('wrapper')}>
        {DropdownButton}
        <VelocityComponent
          animation={active ? 'transition.slideDownIn' : 'transition.fadeOut'}
          duration={150}
          display={active ? 'block' : 'none'}
        >
          {this.renderMenu()}
        </VelocityComponent>
      </div>
    );
  }
}

const DropdownMenuWithOnClickOutside = onClickOutside<IOwnProps>(DropdownMenu);

export default DropdownMenuWithOnClickOutside;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/blocks/DropdownMenu/index.tsx